import { UnitType } from '../types/units';

export const UNIT_TYPES: Array<UnitType> = [UnitType.METRIC, UnitType.IMPERIAL, UnitType.NAUTICAL];

/*
 * All translations are based on the following sources:
 * https://www.google.com/search?q=meter+to+fathom&oq=meter+to+fathom&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIGCAEQBhhA0gEINjY1NWowajeoAgCwAgA&sourceid=chrome&ie=UTF-8
 */

// Metric system
export const METERS_PER_SECOND_TO_KMH = 3.6;
export const KM_TO_METER = 1000;
export const METER_TO_KM = 1 / KM_TO_METER;
export const METER_TO_METER = 1;
export const DECIMETER_TO_METER = 0.1;

// Imperial system
export const METERS_PER_SECOND_TO_MPH = 2.23694;
export const KMH_TO_MPH = 0.621371;

export const MILE_TO_METER = 1609.34;
export const MILE_TO_KM = MILE_TO_METER / 1000;
export const METER_TO_MILE = 1 / MILE_TO_METER;

export const FOOT_TO_METER = 0.3048;
export const METER_TO_FOOT = 1 / FOOT_TO_METER;

const MILE_TO_FOOT = 5280;
export const FOOT_TO_MILE = 1 / MILE_TO_FOOT;

// Nautical System
export const METERS_PER_SECOND_TO_KNOTS = 1.94384; // 1 Knot => 1 Nautic Mile per hour
export const KMH_TO_KNOTS = 0.539957; // 1 km/h => 0.539957 Knots

export const NAUTICAL_MILE_TO_METER = 1852;
export const NAUTICAL_MILE_TO_KM = NAUTICAL_MILE_TO_METER / 1000;
export const METER_TO_NAUTICAL_MILE = 1 / NAUTICAL_MILE_TO_METER;

export const FATHOM_TO_METER = 1.8288;
export const METER_TO_FATHOM = 1 / FATHOM_TO_METER; // 1 Fathom => 1.8288 meters

const NAUTICAL_MILE_TO_FATHOM = NAUTICAL_MILE_TO_METER / FATHOM_TO_METER; // 1 Nautical Mile => 1852 meters => 1852/1.8288 Fathoms
export const FATHOM_TO_NAUTICAL_MILE = 1 / NAUTICAL_MILE_TO_FATHOM;
